import { render, staticRenderFns } from "./userDetailOrder.vue?vue&type=template&id=22ddc58d&scoped=true"
import script from "./userDetailOrder.vue?vue&type=script&lang=js"
export * from "./userDetailOrder.vue?vue&type=script&lang=js"
import style0 from "./userDetailOrder.vue?vue&type=style&index=0&id=22ddc58d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddc58d",
  null
  
)

export default component.exports